import { NgModule } from '@angular/core';
import { ThemingService } from './theming.service';

@NgModule({
  providers: [
    ThemingService
  ]
})
export class ColorsModule {}
